import { Component, ElementRef, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { TemplatesNewCalendarService } from 'src/app/services/templates-new-calendar.service';
import { DatePipe } from '@angular/common';
import { CabinSchedules } from 'src/app/models/cabin_schedules';
import { NgbDateStruct, NgbModal, NgbTimepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendarComponent } from '@fullcalendar/angular';
import esLocale from '@fullcalendar/core/locales/es';
import tippy from 'tippy.js';
import { firstValueFrom } from 'rxjs';

import { PaymentMethods } from 'src/app/models/paymentMethods';
import { Payments } from 'src/app/models/payments';
import { AreasWorked } from 'src/app/models/areas_worked';
import { Users } from 'src/app/models/users';
import { TypePackages } from 'src/app/models/type_packages';
import { Clients } from 'src/app/models/clients';
import { PackagesAgenda } from 'src/app/models/packages_agenda';
import { appointmentsClients } from 'src/app/models/appt_clients';
import { PackageSelected } from 'src/app/models/package_selected';
import { Package2 } from 'src/app/models/package2';
import { HistoricalComments } from 'src/app/models/historical_comments';
import { AppointmentsAgenda } from 'src/app/models/appointments_agenda';
import { SharedService } from 'src/app/services/shared.service';
import { RemainingCalendar } from 'src/app/models/remaining_calendar';
import { formatDate } from '@fullcalendar/core';

interface FilterUsers {
  value: number;
  label: string;
}

type Times = {
  hour: number | string;
  minute: number | string;
  second?: number | string;
};

@Component({
  selector: 'app-new-calendar',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './new-calendar.component.html',
  styleUrls: ['./new-calendar.component.scss'],
  providers: [DatePipe, NgbTimepickerConfig]
})
export class NewCalendarComponent implements OnInit {
  cabins: CabinSchedules[] = [];
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  @ViewChild('calendar', { read: ElementRef }) calendarRef!: ElementRef;
  @ViewChild('modalContent', { static: false }) modalContent!: TemplateRef<any>;
  @ViewChild('createSession', { static: false }) createSession!: TemplateRef<any>;
  @ViewChild('changeTime', { static: false }) changeTime!: TemplateRef<any>;
  @ViewChild('historicalComments', { static: false }) historicalComments!: TemplateRef<any>;
  @ViewChild('sessionsClients', { static: false }) sessionsClients!: TemplateRef<any>;
  @ViewChild('closeBoxModal', { static: false }) closeBoxModal!: TemplateRef<any>;
  @ViewChild('scheduleVacationsModal', { static: false }) scheduleVacationsModal!: TemplateRef<any>;
  @ViewChild('confirmAssisted', { static: false }) confirmAssisted!: TemplateRef<any>;
  @ViewChild('iconsMap', { static: false }) iconsMap!: TemplateRef<any>;

  modalClose: any;
  dataSessionInfo: any;
  messageTextAssisted: string = '';
  messageTextReschedule: string = '';
  messageAdvancePayments: string = '';
  messageExtraPaymentSession: string = '';
  messageTextPaymentDone: string = '';
  messagesPayments: string = '';
  messagesAreasWork: string = '';
  messageTextFinishSession: string = '';
  messageNewSession: string = '';
  messageZero: string = '';
  messageAcceptance: string = '';
  dynamicMessage: string = 'Selecciona una sesión a agendar';
  setDateForMeetings: string = '';
  timeSession: string = '';
  clientName: string = '';
  keyRole: string = '';
  typeColor: string = '';
  temporalCompleteTime: Times = { hour: '', minute: '', second: '' };
  selectedEventId: string | null = null;
  selectedEventDate: Date | null = null;
  temporalSelectedDate: any = '';

  step: number = 0;
  saldoExtraTotal: number = 0;
  saldoTotal: number = 0;
  lastProduct: number = 0;
  oldPayment: number = 0;
  flagTypeSession: number = 0;
  flagTypeClient: number = 0;
  showScheduleSession: number = 0;
  clientColSize: number = 12;
  paymentMethods: PaymentMethods[] = [];
  payments: Payments[] = [];
  paymentsFilter: Payments[] = [];
  paymentsInfo: any = [];
  sessionInfo: any = [];
  areasInformation: any = [];
  areasWorked: AreasWorked[] = [];
  arrayIds: Array<number|string> = [];
  employees: Users[] = [];
  onlyNurses: Users[] = [];
  filterEmployees: FilterUsers[] = [];
  typePackagesAvailable: TypePackages[] = [];
  clients: Clients[] = [];
  perClientsChecks: Clients[] = [];
  perClients: any[] = [];
  clientsFilter: any[] = [];
  clientsOptions: any[] = [];
  packages: PackagesAgenda[] = [];
  packageFilter: any[] = [];
  sessionAppExists: appointmentsClients[] = [];
  temporalPackageSelected: PackageSelected[] = [];
  areasPackageSelected: Package2[] = [];
  storeAreasPackageIds: number[] = [];
  historicalCommentsInfo: HistoricalComments[] = [];
  appointmesAgendaPerDay: AppointmentsAgenda[] = [];
  blockedRanges: any[] = [];
  closeBox: any = [];
  closeBoxChange: any = [];
  areasInfoWorkec: any = [];
  sellsPerOffice!: RemainingCalendar;

  // Boolean variables
  assistedFlag: boolean = false;
  submitAssisted: boolean = false;
  submitReschedule: boolean = false;
  submitExists: boolean = false;
  submitAdvancePayment: boolean = false;
  submitPayments: boolean = false;
  submitComments: boolean = false;
  submitValoration: boolean = false;
  submitApptV1: boolean = false;
  submitAppt: boolean = false;
  submitVacations: boolean = false;
  submitCapacitation: boolean = false;
  editHourSession: boolean = false;
  uptHourSubmitExists: boolean = false;
  acceptedSession: boolean = false;
  disabledButtons: boolean = false;
  disabledAcceptanceButton: boolean = false;
  noAssistFlag: boolean = false;
  rescheduleFlag: boolean = false;
  areasWorkedFlag: boolean = false;
  newPaymentsAdded: boolean = false;
  paymentMethodFlag: boolean = false;
  extraShowFlag: boolean = false;
  newExtraPays: boolean = false;
  extraPaymentSession: boolean = false;
  submitExtraPayments: boolean = false;
  hasRemaining: boolean = false;
  paymentDoneFlag: boolean = false;
  isPaid: boolean = false;
  isPaidFlag: boolean = false;
  completeTransactions: boolean = false;
  disabledAmountField: boolean = false;
  valorationFlag: boolean = false;
  areasMissingSubmitted: boolean = false;
  areasFlagDone: boolean = false;
  disabledChecks: boolean = false;
  disabledAll: boolean = false;
  sessionFinishedFlag: boolean = false;
  typeSession: boolean = false;
  disabledNewSession: boolean = false;
  flagValueZero: boolean = false;
  flagSessionActive: boolean = false;
  disabledScheduleButton: boolean = false;
  flagEndTimeValidation: boolean = false;
  showTables: boolean = false;
  flagSimpleAreas: boolean = false;
  flagSimpleArea: boolean = false;
  flagClientOpen: boolean = false;
  disabledChangeTimeMessage: boolean = false;
  flagSearchModal: boolean = false;
  isManualNavigation: boolean = false;
  currentCalendarDate: any;

  // Forms
  updateFormSession: any = FormGroup;
  cancelForm: any = FormGroup;
  rescheduleForm: any = FormGroup;
  addPaymentsForm: any = FormGroup;
  extraProductsForm: any = FormGroup;
  paymentsForm: any = FormGroup;
  missingForm: any = FormGroup;
  finalCommentsForm: any = FormGroup;
  apptValorationForm: any = FormGroup;
  apptExistsV1: any = FormGroup;
  apptExists: any = FormGroup;
  vacationsForm: any = FormGroup;
  capacitationForm: any = FormGroup;
  maderoForm: any = FormGroup;
  changeTimeForm: any = FormGroup;
  clientsSearchForm: any = FormGroup;
  updateSessionForm: any = FormGroup;

  // ngModel
  startSession: Times = { hour: '', minute: '', second: ''};
  timeStart: Times = { hour: '', minute: '', second: ''};
  endSession: Times = { hour: '', minute: '', second: ''};
  timeEnd: Times = { hour: '', minute: '', second: ''};
  startVacations: Times = { hour: '', minute: '', second: ''};
  endVacations: Times = { hour: '', minute: '', second: ''};
  startCapacitation: Times = { hour: '', minute: '', second: ''};
  endCapacitation: Times = { hour: '', minute: '', second: ''};
  changeTimeStart: Times = { hour: '', minute: '', second: ''};
  changeTimeEnd: Times = { hour: '', minute: '', second: ''};

  // FullCalendar options object
  calendarOptions: any = {
    schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
    locale: esLocale,
    timeZone: 'local', //'America/Mexico_City',
    nowIndicator: true,
    plugins: [resourceTimeGridPlugin, interactionPlugin],
    initialView: 'resourceTimeGridDay',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'resourceTimeGridDay,resourceTimeGridWeek'
    },
    titleFormat: (args: any) => {
      const currentDate = new Date(args.start.marker);
      currentDate.setMinutes(currentDate.getMinutes() + currentDate.getTimezoneOffset());

      const text = currentDate.toLocaleDateString('es-ES', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    slotMinTime: '09:00:00',  // start at 9 AM
    slotMaxTime: '21:00:00',
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
    },
    eventMinHeight: 0,
    editable: true,
    selectable: true,
    droppable: true,
    allDaySlot: false,
    slotDuration: '00:10:00',
    resources: [],
    events: [],
    height: '75vh',
    datesSet: (arg: any) => {
      if (!this.calendarComponent) {
        return;
      }

      this.currentCalendarDate = arg.startStr.split('T')[0];
      console.log('START STR:', arg.startStr);
      console.log('END STR:', arg.endStr);
      console.log('-- CURRENT DATE: ', this.currentCalendarDate);

      this.fetchAppoinments(arg.startStr);
      /* console.log('Hola amigos!!!');
      if (!this.calendarComponent) {
        return;
      }

      console.log('Hola amigos 123!!!');
      if (this.isManualNavigation) {
        console.log('Hola amigos enter!!!');
        this.isManualNavigation = false;

        const calendarApi = this.calendarComponent.getApi();
        const currentDate = calendarApi.getDate();

        this.fetchAppoinments(currentDate);
        return;
      }
 
      console.log('Amigos outside if!!!!');
      const calendarApi = this.calendarComponent.getApi();
      const currentDate = calendarApi.getDate();
      console.log('CurrentDate: ', currentDate);
      this.fetchAppoinments(currentDate); */
    },
    eventDrop: (info: any) => {
      const newRoom = info.event.getResources()[0].id;
      this.dragDropEvent(newRoom, info.event.startStr, info.event.extendedProps.object);
    },
    eventResize: (info: any) => {
      const oldStart = info.oldEvent.start;
      const oldEnd = info.oldEvent.end;
      const newStart = info.event.start;
      const newEnd = info.event.end;
      const resource = info.event.getResources()[0];
      const roomId = resource?.id;

      const oldDuration = oldEnd.getTime() - oldStart.getTime();
      const newDuration = newEnd.getTime() - newStart.getTime();

      if (newDuration > oldDuration) {
        info.revert();
        return;
      }

      this.resizePerLessTime(roomId, newStart, newEnd, info.event.extendedProps.object);
    },
    eventContent: (args: any) => {
      if (args.event.extendedProps?.isBlocked) {
        return;
      }

      const props = args.event.extendedProps.object;
      console.log('objects: ', props);
      
      const html = this.templateCalendar.getTemplatesPerType(props, true);
      console.log('estoy aqui???');
      return { html };
    },
    eventDidMount: (info: any) => {
      if (info.event.extendedProps?.isBlocked) {
        return;
      }

      info.el.setAttribute('data-event-id', info.event.id);
      const props = info.event.extendedProps.object;
      const content = this.templateCalendar.getTemplatesPerType(props, false);

      /** Buttons */
      const selectorInformation = info.el.querySelector('.btn-info');
      const selectorChangeTime = info.el.querySelector('.btn-change-time');
      const selectorCommentsHistorical = info.el.querySelector('.btn-comments-historical');
      const selectorRedirectToUsers = info.el.querySelector('.btn-redirect-user');
      
      if (selectorInformation) {
        selectorInformation?.addEventListener('click', (evt: any) => {
          evt.stopPropagation();

          const sessionId = Number((evt.currentTarget as HTMLElement).getAttribute('data-id')) || null;
          this.handleInformationData(sessionId, info.event.extendedProps?.object);
        });
      }

      if (selectorChangeTime) {
        selectorChangeTime?.addEventListener('click', (event: any) => {
          event.stopPropagation();

          const infoRecord = info.event.extendedProps.object;
          console.dir('-- Info: ', infoRecord);
          const timeEndSplit = new Date(infoRecord.sessions.dateEnd);
          const timeStartSplit = new Date(infoRecord.sessions.dateStart);

          this.changeTimeStart = {
            hour: timeStartSplit.getHours(),
            minute: timeStartSplit.getMinutes(),
            second: 0
          };
          this.changeTimeEnd = { 
            hour: timeEndSplit.getHours(), 
            minute: timeEndSplit.getMinutes(), 
            second: 0
          };
          this.changeTimeForm.patchValue({
            sessionId: infoRecord.sessions.id
          });

          this.modalClose = this.modal.open(this.changeTime, { size: 'lg' });
        });
      }

      if (selectorCommentsHistorical) {
        selectorCommentsHistorical.addEventListener('click', (event: any) => {
          event.stopPropagation();

          const sessionId = Number((event.currentTarget as HTMLElement).getAttribute('data-id')) || null;
          this.showHistoricalComments(sessionId);

          this.modalClose = this.modal.open(this.historicalComments, { size: 'xl' });
        });
      }

      if (selectorRedirectToUsers) {
        selectorRedirectToUsers.addEventListener('click', (event: any) => {
          event.stopPropagation();

          const sessionId = Number((event.currentTarget as HTMLElement).getAttribute('data-id')) || null;
          this.redirectToUsers(sessionId);
        });
      }

      /* `
        <div class="fc-tooltip-content">
          <div class="fw-bold mb-1">
            🤩 ${props.client.identifier} ${props.client.shared_names}
          </div>

          <div class="small">
            📞 ${props.client.phone}
          </div>

          <div class="small">
            ⏰ ${props.sessions.timeStart} - ${props.sessions.timeEnd}
          </div>

          <div class="small">
            🏢 Cabin: ${props.cabins?.name ?? ''}
          </div>
        </div>
      ` */

      tippy(info.el, {
        content,
        allowHTML: true,
        trigger: 'mouseenter',
        //theme: 'fc-light',
        //animation: 'shift-away',
        hideOnClick: true,
        interactive: false,
        delay: [100, 100],
        appendTo: document.body,   // 🔥 VERY IMPORTANT
        zIndex: 99999,
        placement: 'top',
      });
    },
    dateClick: (info: any) => {
      console.log('Fecha: ', typeof info.resource?.id, info.dateStr);
      const roomId = info.resource?.id

      /* const [datePart, timePart] = info.dateStr.split('T');
      const [year, month, day] = datePart.split('-').map(Number);
      const [hour, minute, second = 0] = timePart.split(':').map(Number);

      const start = new Date(year, month - 1, day, hour, minute, second);
      const end = new Date(start.getTime() + 10 * 60 * 1000); */
      const start = new Date(info.dateStr);
      const end = new Date(start.getTime() + 10 * 60 * 1000);

      console.log('-- START:', start);
      console.log('-- END:', end);

      this.temporalSelectedDate = start;

      if (this.isBlocked(roomId, start, end)) {
        console.log('Error: selected time is blocked');
        return;
      }

      this.createSessionsModal(info);
      /* const start = new Date(info.date);
      const end = new Date(info.date);
      console.log('-- START: ', start);
      console.log('-- END: ', end);
      end.setMinutes(end.getMinutes() + 10);
      console.log('-- END 2: ', end);
      this.temporalSelectedDate = start;
      console.log('-- TEMPORAL DATE: ', this.temporalSelectedDate);

      if (this.isBlocked(roomId, start, end)) {
        console.log('Error');
        return;
      }

      // call the function will be used to open modal to create sessions
      this.createSessionsModal(info); */
    },
    selectAllow: (selectInfo: any) => {
      return !this.isBlocked(selectInfo.resource?.id, selectInfo.start, selectInfo.end);
    },
    eventAllow: (dropInfo: any) => {
      return !this.isBlocked(dropInfo.resource?.id, dropInfo.start, dropInfo.end);
    }
  };

  constructor (private api: ApiService, 
              private datePipe: DatePipe,
              private router: Router,
              private templateCalendar: TemplatesNewCalendarService,
              private modal: NgbModal,
              private updtFormSession: FormBuilder,
              private cancelFormSession: FormBuilder,
              private rescheduleFormSession: FormBuilder,
              private addPaymentsFormSession: FormBuilder,
              private extraProductsFormSession: FormBuilder,
              private paymentsFormSession: FormBuilder,
              private missingFormSession: FormBuilder,
              private finalCommentsFormSession: FormBuilder,
              private apptValorationFormSession: FormBuilder,
              private appExistsV1Session: FormBuilder,
              private appExistsFormSession: FormBuilder,
              private vacationsFormSession: FormBuilder,
              private capacitationFormSession: FormBuilder,
              private maderoFormSession: FormBuilder,
              private changeTimeFormSession: FormBuilder,
              private clientSearchFormSession: FormBuilder,
              public config: NgbTimepickerConfig,
              private sharedServices: SharedService) {
  }

  ngOnInit(): void {
    this.fetchRooms();
    this.getClients();
    this.getEmployees();
    this.getPaymentMethods();
    this.getPayments();
    this.getTypePackages();
    this.sellsData();
    this.loggedInEmployee();
    this.validations();
    this.getAreasInformation();
  }

  // Validations Section
  validations(): void {
    this.updateFormSession = this.updtFormSession.group({
      sessionId: ['', [Validators.required]],
      originalCabin: [''],
      cabinNumber: [''],
      duration: ['']
    });

    this.cancelForm = this.cancelFormSession.group({
      comments: [''],
      id: [''],
      type: ['']
    });

    this.rescheduleForm = this.rescheduleFormSession.group({
      newDay: ['', [Validators.required]],
      sessionId: ['', [Validators.required]]
    });

    this.addPaymentsForm = this.addPaymentsFormSession.group({
      sessionId: ['', [Validators.required]],
      paymentMethodId: ['', [Validators.required]],
      terminal: [''],
      paymentId: ['0', [Validators.required]],
      amount: ['', [Validators.required]],
      apptId: ['', [Validators.required]]
    });

    this.extraProductsForm = this.extraProductsFormSession.group({
      extra: [''],
      sessionId: ['', [Validators.required]],
      paymentMethodId: ['', [Validators.required]],
      terminal: [''],
      paymentId: ['0', [Validators.required]],
      amount: ['', [Validators.required]],
      remainingPayment: ['', [Validators.required]]
    });

    this.paymentsForm = this.paymentsFormSession.group({
      paymentMethodId: ['', [Validators.required]],
      sessionId: ['', [Validators.required]],
      paymentId: ['0', [Validators.required]],
      remainingPaymentId: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      terminal: ['0'],
      apptId: ['', [Validators.required]],
      changeAmount: [''],
      originalAmount: ['']
    });

    this.missingForm = this.missingFormSession.group({
      sessionId: ['', [Validators.required]],
      areas: ['', [Validators.required]],
      apptId: ['', [Validators.required]],
      packageId: ['', [Validators.required]]
    });

    this.finalCommentsForm = this.finalCommentsFormSession.group({
      employeeId: ['', [Validators.required]],
      finalComment: ['']
    });

    this.apptValorationForm = this.apptValorationFormSession.group({
      typeUser: [''],
      clientIdValue: [''],
      apptIdValue: [''],
      nameNoClient: [''],
      employeeIdValue: ['', [Validators.required]],
      employeeIdValueTemp: [''],
      dateSessionValue: ['', [Validators.required]],
      officeIdValue: ['', [Validators.required]],
      commentsValue: [''],
      cabinNumberValue: [''],
      cabinIdValue: ['', [Validators.required]]
    });

    this.apptExistsV1 = this.appExistsV1Session.group({
      clientId: ['', [Validators.required]],
      packageId: ['', [Validators.required]],
      cabinId: ['', [Validators.required]],
      dateSession: ['', [Validators.required]],
      employeeId: ['', [Validators.required]],
      employeeIdTemp: [''],
      comments: [''],
      cabinNumber: ['']
    });

    this.apptExists = this.appExistsFormSession.group({
      type: [''],
      clientId: ['', [Validators.required]],
      apptId: ['', [Validators.required]],
      packageId: ['', [Validators.required]],
      cabinId: ['', [Validators.required]],
      dateSession: ['', [Validators.required]],
      sessionNumber: ['', [Validators.required]],
      employeeId: ['', [Validators.required]],
      employeeIdTemp: [''],
      officeId: ['', [Validators.required]],
      totalSessions: ['', [Validators.required]],
      comments: [''],
      cabinNumber: [''],
      flagCustom: [''],
      customAreasSessions: ['']
    });

    this.vacationsForm = this.vacationsFormSession.group({
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      officeId: [''],
      cabinId: [''],
      employeeId: ['', [Validators.required]],
      temporalEmployeeId: ['']
    });

    this.capacitationForm = this.capacitationFormSession.group({
      startDateCap: ['', [Validators.required]],
      officeId: ['', [Validators.required]],
      cabinId: ['', [Validators.required]],
      employeeId: ['', [Validators.required]],
      temporalEmployeeId: [''],
      customTitle: [null],
      comments: ['', [Validators.required]]
    });
    
    this.maderoForm = this.maderoFormSession.group({
      type: [''],
      clientId: ['', [Validators.required]],
      apptId: ['', [Validators.required]],
      packageId: ['', [Validators.required]],
      cabinId: ['', [Validators.required]],
      dateSession: ['', [Validators.required]],
      sessionNumber: ['', [Validators.required]],
      employeeId: ['', [Validators.required]],
      employeeIdTemp: [''],
      officeId: ['', [Validators.required]],
      totalSessions: ['', [Validators.required]],
      comments: [''],
      cabinNumber: [''],
      flagCustom: [''],
      customAreasSessions: ['']
    });

    this.changeTimeForm = this.changeTimeFormSession.group({
      sessionId: ['', [Validators.required]]
    });

    this.clientsSearchForm = this.clientSearchFormSession.group({
      searchClient: ['']
    });
  }

  // API Calls Section
  async getDataPerSessionId(sessionId: number): Promise<any> {
    return await firstValueFrom(this.api.get(`sessions/agenda/${sessionId}`));
  }

  async getPackages(clientId: number): Promise<any> {
    return await firstValueFrom(this.api.getById('packages/clients', clientId));
  }

  async sessionInformation(clientId: number) {
    return await firstValueFrom(this.api.getById('appoinments/clients', clientId));
  }

  async updateClientPackage(event: any, type: Number = 0) {
    console.log('holas amigos');
    this.disabledScheduleButton = false;
    const clientId = event.value;

    if (!clientId) {
      this.resetClientView();

      return;
    }

    console.log('hoa despues');
    console.log('Cliente: ', clientId);

    const [packages, sessionsInformation] = await Promise.all([
      this.getPackages(clientId),
      this.sessionInformation(clientId)
    ]);

    this.packages = packages.packages;
    this.sessionAppExists = sessionsInformation.appoinments;
    console.log('-- Tipo de Paquete: ', type);
    console.log('-- Paquetes: ', this.packages);
    console.log('-- Sessions: ', this.sessionAppExists);

    const packagesFormat = this.packages
      .filter((pkg: any) => Number(pkg.type_id) === Number(type))
      .map((packageInfo: any) => {
        return {
          value: packageInfo.id,
          label: packageInfo.session,
        };
      });

    this.packageFilter = [{ options: packagesFormat }];
    console.log('holas amigos');
    this.packageFilter = this.packages.filter((data: any) => {
      return data.client.id === clientId && this.setCondition(data) && data.type_id === type;
    });
    console.log("-- final package: ", this.packageFilter);

    if (!this.packageFilter.length) {
      this.handleNoPackages();

      return;
    }

    this.showScheduleSession = 1;
    const sessionActive = this.getActiveSession();
    const info = sessionActive?.sessions?.information?.[0];
    const hasUnfinishedSession = info && !info.session_close && info.assisted === 2;

    if (hasUnfinishedSession) {
      this.disabledNewSession = true;
      this.disabledScheduleButton = false;
      this.messageNewSession = 'No puedes agendar nueva sesion. El cliente seleccionado tiene una sesion no finalizada.';

      return;
    }

    this.disabledNewSession = false;
    if (this.packageFilter.length) {
      this.flagClientOpen = true;
      this.clientColSize = 6;
      this.apptExists.patchValue({ clientId: this.packageFilter[0].client.id });
      this.maderoForm.patchValue({ clientId: this.packageFilter[0].client.id });
    } else {
      this.flagClientOpen = false;
      this.clientColSize = 12;
    }

    /*if (sessionActive !== undefined && sessionActive.sessions.information && 
        !sessionActive.sessions.information[0].session_close && sessionActive.sessions.information[0].assited === 2) {
          this.disabledNewSession = true;
          this.disabledScheduleButton = false;
          this.messageNewSession = 'No puedes agendar nueva sesion. El cliente seleccionado tiene una sesion no finalizada.';
    } else {
      this.disabledNewSession = false;

      if (this.packageFilter.length !== 0) {
        this.flagClientOpen = true;
        this.clientColSize = 6;

        this.apptExists.patchValue({
          clientId: this.packageFilter[0].client.id
        });
      } else {
        this.flagClientOpen = false;
        this.clientColSize = 12;
      }
    }*/
  }

  loggedInEmployee() {
    this.api.get('employee').subscribe({
      next: (employee) => {
        if (typeof employee !== undefined) {
          const startHour = employee.employee.office.start.split(':');
          const endHour = employee.employee.office.end.split(':');

          //this.hourStartAppt = Number(startHour[0]);
          //this.hourEndAppt = Number(endHour[0]);
          //this.loggedEmployee = employee.employee;
          this.keyRole = employee.employee.roles.key.toLowerCase();
          this.calendarComponent.getApi().setOption('slotMinTime', `${startHour[0].toString().padStart(2, '0')}:${startHour[1].toString().padStart(2, '0')}:00`);
          this.calendarComponent.getApi().setOption('slotMaxTime', `${endHour[0].toString().padStart(2, '0')}:${endHour[1].toString().padStart(2, '0')}:00`);
        }
      }
    });
  }

  fetchRooms(): void {
    this.api.get('cabin').subscribe({
      next: rooms => {
        this.cabins = rooms.cabins;
        this.calendarOptions.resources = rooms.cabins.map((room: any) => ({
          id: room.id,
          title: room.name
        }));
      }
    });
  }

  getPaymentMethods() {
    this.api.get('payment_methods').subscribe({
      next: (paymentMethods) => {
        this.paymentMethods = paymentMethods.payment_methods;
      },
    });
  }

  getAreasInformation() {
    this.api.get('areas/catalog/1').subscribe({
      next: (areas) => {
        this.areasInformation = areas.areas;
      }
    });
  }

  getPayments() {
    this.api.get('payments').subscribe({
      next: (payments) => {
        this.payments = payments.payments;
      },
    });
  }

  getEmployees() {
    this.api.get('employees').subscribe({
      next: (employees) => {
        this.employees = employees.employees.filter(
          (data: any) => data.is_displayed
        );
        const employeesPackage = this.employees.map((employeeData: any) => {
          return {
            value: employeeData.id,
            label: `${employeeData.first_name} ${employeeData.last_name}`,
          };
        });
        this.filterEmployees = employeesPackage;

        // only nurses
        this.onlyNurses = this.employees.filter(
          (employee: any) => employee.roles.key === 'enf'
        );
      }
    });
  }

  getClients() {
    this.api.get('clients').subscribe({
      next: (clients) => {
        this.clients = clients.clients;
        this.perClientsChecks = clients.clients;

        const clientsFormat = this.clients.map((client: any) => {
          return {
            value: client.id,
            label: `${client.first_name} ${client.last_name}`,
          };
        });
        const perClientsFormat = this.clients.map((perClient: any) => {
          return {
            value: perClient.id,
            label: perClient.complete
          };
        });

        this.clientsFilter = [{ options: clientsFormat }];
        this.clientsOptions = [{ options: perClientsFormat }];
      },
      error: (err) => {},
    });
  }

  getTypePackages(): void {
    this.api.get('v1/package/type/1').subscribe({ //v1/package/type/1
      next: (typePackage) => {
        this.typePackagesAvailable = typePackage.data;
      }
    });
  }

  sellsData() {
    this.api.getById('remaining', Date.now()).subscribe({
      next: (sells) => {
        this.sellsPerOffice = sells.data_sells;
        console.log(this.sellsPerOffice.totalPerOffice);
      }
    });
  }

  fetchAppoinments(currentDate: Date): void {
    const formatedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
    this.api.get(`v1/appoinments/offices/${formatedDate}`).subscribe({
      next: (response) => {
        const calendarApi = this.calendarComponent.getApi();
        calendarApi.removeAllEvents();

        this.appointmesAgendaPerDay = response.appoinments;
        this.blockedRanges = response.blocked.map((block: any) => ({
          roomId: String(block.roomId),
          start: new Date(`${formatedDate}T${block.start}`),
          end: new Date(`${formatedDate}T${block.end}`),
        }));

        const newEvents = response.appoinments.map((event: any) => { 
          
          if (!event.packages.id) {
            event.packages.type_id = event.sessions.type_session + 10;
          }

          const {backgroundColor, borderColor, textColor} = this.templateCalendar.getColorsPerType(event.packages.type_id, 
                                                                                                   event.sessions.assisted, 
                                                                                                   event);

          return {
            id: event.sessions.id,
            title: event.shared_names,
            start: event.sessions.dateStart,
            end: event.sessions.dateEnd,
            resourceId: String(event.cabins.id),
            backgroundColor,
            borderColor,
            textColor,
            extendedProps: {
              object: event
            }
          }
        });

        const blockedEvents = response.blocked.map((block: any) => ({
          start: `${formatedDate}T${block.start}`,
          end: `${formatedDate}T${block.end}`,
          resourceId: String(block.roomId),
          display: 'background',
          backgroundColor: '#5E5E5E',
          extendedProps: {
            isBlocked: true
          }
        }));

        console.log(blockedEvents);

        newEvents.forEach((evt: any) => {
          calendarApi.addEvent(evt);
        });

        blockedEvents.forEach((evt: any) => {
          calendarApi.addEvent(evt);
        });

        this.afterEventsLoaded();

        console.log('Events Added: ', newEvents);
        console.log('Blocks Added: ', blockedEvents);
      }
    });
  }

  assistedUser(status: number, sessionId: number): void {
    const params = `${Number(sessionId)}/${Number(status)}`;
    this.api.getById('sessions/checks', params).subscribe({
      next: (session) => {
        if (session.session.assisted) {
          this.acceptedSession = true;
        }

        this.assistedFlag = true;
        this.submitAssisted = true;
        this.messageTextAssisted = session.session.assisted ? 'Se confirmo la asistencia' : 'Se confirmo la no asistencia';
        this.disabledButtons = session.session.assisted === 0 ? true : false;

        setTimeout(() => {
          this.assistedFlag = false;
          this.submitAssisted = false;
        }, 3000);
      }
    });
  }

  noAssistChecks(): void {
    const obj = {
      id: this.cancelForm.value.id,
      status: this.cancelForm.value.type,
      comment: this.cancelForm.value.comments
    }

    this.api.create('sessions/nochecks', obj).subscribe({
      next: (data) => {
        this.acceptedSession = true;
        this.assistedFlag = true;
        this.submitAssisted = true;
        this.noAssistFlag = false;
        this.messageTextAssisted = data.session.assisted ? 'Se confirmo la asistencia' : 'Se confirmo la no asistencia';
        this.disabledButtons = data.session.assisted === 0 ? true : false;

        setTimeout(() => {
          this.assistedFlag = false;
          this.submitAssisted = false;
        }, 3000);
      }
    });
  }

  rescheduleSession(): void {
    this.submitReschedule = true;

    if (this.rescheduleForm.invalid) {
      console.log('-- Invalid: ', this.rescheduleForm);
      this.submitReschedule = false;
      return;
    }

    const obj = {
      newDay: this.rescheduleForm.value.newDay,
      timeStart: this.startSession,
      timeEnd: this.endSession
    };
    const id = this.rescheduleForm.value.sessionId;

    this.api.update('sessions/reschedule', Number(id), obj).subscribe({
      next: (dataUpdated) => {
        // TODO: Create process to update calendar
        this.showRescheduleForm(false);
        this.messageTextReschedule = dataUpdated.message;

        setTimeout(() => {
          this.messageTextReschedule = '';
          this.submitReschedule = false;
          this.rescheduleForm.reset();
        }, 3000);

        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  addNewPayments(): void {
    this.submitAdvancePayment = true;

    if (this.addPaymentsForm.invalid) {
      this.submitAdvancePayment = false;
      return;
    }

    const obj = {
      sessionId: this.addPaymentsForm.value.sessionId,
      paymentMethodId: this.addPaymentsForm.value.paymentMethodId,
      terminal: this.addPaymentsForm.value.terminal,
      paymentId: this.addPaymentsForm.value.paymentId,
      amount: this.addPaymentsForm.value.amount,
      apptId: this.addPaymentsForm.value.apptId
    };

    this.api.create('payments_sessions/advance', obj).subscribe({
      next: (paymentData) => {
        this.messageAdvancePayments = paymentData.message;

        if (paymentData.printTicket.state_code === 'Bc') {
          this.api.onPrintRecipientPeninsula(paymentData.printTicket);
        } else {
          this.api.onPrintRecipient(paymentData.printTicket);
        }

        setTimeout(() => {
          this.resetFieldsAdvancePayments();
          this.submitAdvancePayment = false;
          this.newPaymentsAdded = false;
          this.messageAdvancePayments = '';

          // TODO: check reload
        }, 3000);
      }
    });
  }

  saveExtraProducts(): void {
    this.submitExtraPayments = true;

    if (this.extraProductsForm.invalid) {
      this.submitExtraPayments = false;
      return;
    }

    const obj = {
      amount: this.extraProductsForm.value.amount,
      paymentMethodId: this.extraProductsForm.value.paymentMethodId,
      terminal: this.extraProductsForm.value.terminal,
      sessionId: this.extraProductsForm.value.sessionId,
      extra: this.extraProductsForm.value.extra,
      paymentId: this.extraProductsForm.value.paymentId,
      remainingPayment: this.extraProductsForm.value.remainingPayment
    };

    this.api.create('extra_payment_session', obj).subscribe({
      next: (extraData) => {
        this.extraPaymentSession = true;
        this.messageExtraPaymentSession = extraData.message;

        setTimeout(() => {
          this.submitExtraPayments = false;
          this.extraPaymentSession = false;
          this.newExtraPays = false;
        }, 3000);

        // TODO: Check 
        this.resetExtraPayments();
      }
    });
  }

  savePaymentsSession(): void {
    this.submitPayments = true;

    if (this.paymentsForm.invalid) {
      this.submitPayments = false;
      return;
    }

    const obj = {
      paymentMethodId: this.paymentsForm.value.paymentMethodId,
      sessionId: this.paymentsForm.value.sessionId,
      paymentId: this.paymentsForm.value.paymentId,
      remainingPaymentId: this.paymentsForm.value.remainingPaymentId,
      amount: this.paymentsForm.value.amount,
      terminal: this.paymentsForm.value.terminal,
      apptId: this.paymentsForm.value.apptId,
      customAmount: this.paymentsForm.value.changeAmount,
      originalAmount: this.paymentsForm.value.originalAmount
    };

    this.api.create('payments_sessions', obj).subscribe({
      next: (payments) => {
        this.paymentDoneFlag = true;
        this.messageTextPaymentDone = payments.message;
        this.completeTransactions = true;
        this.submitPayments = false;
        this.isPaid = true;
        this.messagesPayments = payments.message;
        this.isPaidFlag = payments.paymentSessions.is_paid;

        if (payments.paymentSessions.printTicket.state_code === 'Bc') {
          this.api.onPrintRecipientPeninsula(payments.paymentSessions.printTicket);
        } else {
          this.api.onPrintRecipient(payments.paymentSessions.printTicket);
        }

        setTimeout(() => {
          this.messageTextPaymentDone = '';
        }, 3000);

        // TODO: Reload informacion in calendar
        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  missingAreasSession(): void {
    this.areasMissingSubmitted = true;

    if (this.missingForm.invalid) {
      console.log('-- Areas Sessions Form: ', this.missingForm);
      this.areasMissingSubmitted = false;
      return;
    }

    const obj = {
      areas: this.missingForm.value.areas,
      appoinment: this.missingForm.value.apptId,
      session: this.missingForm.value.sessionId,
      package: this.missingForm.value.packageId
    };

    this.api.create('sessions/worked', obj).subscribe({
      next: (missingData) => {
        this.areasWorkedFlag = true;
        this.areasMissingSubmitted = false;
        this.messagesAreasWork = missingData.message;
        this.areasFlagDone = true;

        setTimeout(() => {
          this.messagesAreasWork = '';
        }, 3000);

        // TODO: update records in calendar

        this.sessionInfo[0] = missingData.areas.map((areaInfo: any) => {
          return {
            price: areaInfo.price,
            name: areaInfo.name,
            duration: areaInfo.duration,
            total: areaInfo.number,
            remaining: areaInfo.number - areaInfo.remaining,
            finished: areaInfo.finished,
            active: areaInfo.active
          };
        });
      }
    });
  }

  updateSession(id: number): void {
    this.submitComments = true;

    const obj = {
      final_comment: this.finalCommentsForm.value.finalComment,
      employee_id: this.finalCommentsForm.value.employeeId,
      closed: 1
    };

    this.api.update('sessions/final/comments', id, obj).subscribe({
      next: (finalComments) => {
        // TODO: Reload information
          console.log('-- Demo, si entro a actualizar');
          this.fetchAppoinments(this.currentCalendarDate);
          //this.calendarComponent.getApi().refetchEvents();
        this.sessionFinishedFlag = true;
        this.messageTextFinishSession = finalComments.message;


        setTimeout(() => {
          this.messageTextFinishSession = '';
          this.submitComments = false;
        }, 3000);
      }
    });
  }

  sessionValoration(): void {
    this.flagValueZero = false;
    this.submitValoration = true;
    this.disabledButtons = true;
    this.submitExists = true;
    this.disabledNewSession = false;
    this.disabledScheduleButton = false;
    this.flagEndTimeValidation = false;

    if (this.apptValorationForm.invalid) {
      this.submitExists = true;
      this.disabledButtons = false;

      return;
    }

    const apptValorationForm = this.apptValorationForm.value;

    if (apptValorationForm.typeUser === 1 && apptValorationForm.clientIdValue === 0) {
      this.showValorationError('El cliente registrado seleccionado es incorrecto. Favor de verificarlo o recargar la pagina e intentar registar la sesion de nueva cuenta.');

      return;
    }

    if (apptValorationForm.typeUser !== 1 && apptValorationForm.nameNoClient?.trim() === '0') {
      this.showValorationError('El valor de cliente no registrado es incorrecto. Favor de verificarlo o recargar la pagina e intentar registar la sesion de nueva cuenta.');

      return;
    }

    const startDateValidation = `${apptValorationForm.dateSessionValue.year}-${apptValorationForm.dateSessionValue.month}-${apptValorationForm.dateSessionValue.day} ${this.startSession.hour}:${this.startSession.minute}:00`;

    if (!this.isValidDate(startDateValidation)) {
      this.showValorationError('Por favor, verifica que la fecha de inicio sea valida!');

      return;
    }

    const endDateValidation = `${apptValorationForm.dateSessionValue.year}-${apptValorationForm.dateSessionValue.month}-${apptValorationForm.dateSessionValue.day} ${this.endSession.hour}:${this.endSession.minute}:00`;

    if (!this.isValidDate(endDateValidation)) {
      this.showValorationError('Por favor, verifica que la fecha de termino sea valida!');

      return;
    }

    const obj = {
      type_valoration: apptValorationForm.typeUser,
      client_id: apptValorationForm.clientIdValue,
      nameValoration: apptValorationForm.nameNoClient,
      user_id: apptValorationForm.employeeIdValue,
      dateSession: apptValorationForm.dateSessionValue,
      office_id: apptValorationForm.officeIdValue,
      cabinId: apptValorationForm.cabinIdValue,
      startTime: this.startSession,
      endTime: this.endSession,
      assisted: 2,
      comments: apptValorationForm.commentsValue
    };

    console.log('OBJ: ', obj);
    console.log('-- DATE: ', this.calendarComponent.getApi().getDate());

    this.api.create('sessions/valorations', obj).subscribe({
      next: (valoration) => {
        if (valoration.error) {
          this.showValorationError(valoration.message);

          return;
        }

        this.submitExists = false;
        this.submitValoration = false;

        if (valoration.session?.is_error) {
          this.handleSessionError(valoration.message);

          return;
        }

        this.handleSuccessfulValoration();
        this.fetchAppoinments(this.currentCalendarDate); //this.calendarComponent.getApi().getDate());
      }
    });
  }

  appointmentsV1(): void {
    this.submitApptV1 = true;
    this.disabledButtons = true;
    this.submitExists = false;
    this.flagSessionActive = false;
    this.disabledNewSession = false;
    this.disabledScheduleButton = false;

    if (this.apptExistsV1.invalid) {
      this.submitExists = false;
      this.submitApptV1 = false;

      return;
    }

    const apptExistsV1 = this.apptExistsV1.value;

    const startDateValidation = `${apptExistsV1.dateSession.year}-${apptExistsV1.dateSession.month}-${apptExistsV1.dateSession.day} ${this.startSession.hour}:${this.startSession.minute}:00`;
  
    if (!this.isValidDate(startDateValidation)) {
      this.disabledNewSession = true;
      this.messageNewSession = 'Por favor, verifica que la fecha de inicio sea valida!';

      return;
    }

    const endDateValidation = `${apptExistsV1.dateSession.year}-${apptExistsV1.dateSession.month}-${apptExistsV1.dateSession.day} ${this.endSession.hour}:${this.endSession.minute}:00`;

    if (!this.isValidDate(endDateValidation)) {
      this.disabledNewSession = true;
      this.messageNewSession = 'Por favor, verifica que la fecha de termino sea valida!';

      return;
    }

    const obj = {
      clientId: apptExistsV1.clientId,
      cabinId: apptExistsV1.cabinId,
      cabinNum: apptExistsV1.cabinNumber,
      comments: apptExistsV1.comments,
      userId: apptExistsV1.employeeId,
      packages: apptExistsV1.packageId,
      dateSession: apptExistsV1.dateSession,
      startHour: this.startSession,
      endHour: this.endSession
    };

    //console.log('Object [appointmentsV1()]: ', JSON.stringify(obj));
    this.api.create('v1/sessions', obj).subscribe({
      next: (sessions) => {
        if (sessions.sessions?.is_error) {
          this.handleSessionCreationError(sessions.message);
        } else {
          this.handleSessionCreationSuccess();
        }

        this.flagSimpleAreas = false;
        this.showTables = false;

        // Reload information in full calendar
        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  existsAppointments(): void {
    this.submitAppt = true;
    this.disabledButtons = true;
    this.submitExists = false;
    this.flagSessionActive = false;
    this.disabledNewSession = false;
    this.disabledScheduleButton = false;

    const apptExists = this.apptExists.value;

    const checkHours = this.isFoodTimes(
      this.startSession,
      this.endSession,
      apptExists.cabinId,
      apptExists.employeeId
    );

    if (this.apptExists.invalid) {
      this.submitExists = true;
      this.disabledScheduleButton = true;
      this.submitAppt = false;
      this.disabledButtons = false;

      return;
    }

    const startDateValidation = `${apptExists.dateSession.year}-${apptExists.dateSession.month}-${apptExists.dateSession.day} ${this.startSession.hour}:${this.startSession.minute}:00`;
  
    if (!this.isValidDate(startDateValidation)) {
      this.disabledNewSession = true;
      this.messageNewSession = 'Por favor, verifica que la fecha de inicio sea valida!';

      return;
    }

    const endDateValidation = `${apptExists.dateSession.year}-${apptExists.dateSession.month}-${apptExists.dateSession.day} ${this.endSession.hour}:${this.endSession.minute}:00`;

    if (!this.isValidDate(endDateValidation)) {
      this.disabledNewSession = true;
      this.messageNewSession = 'Por favor, verifica que la fecha de termino sea valida!';

      return;
    }

    const obj = {
      client_id: apptExists.clientId,
      appoinmentId: apptExists.apptId,
      dateSession: apptExists.dateSession,
      cabinId: apptExists.cabinId,
      timeStart: this.startSession,
      endTime: this.endSession,
      sessionNumber: apptExists.sessionNumber,
      user_id: apptExists.employeeId,
      assisted: 2,
      comments: apptExists.comments,
      customAreas: apptExists.customAreasSessions,
      flagCustom: apptExists.flagCustom,
      completeSession: apptExists.type ?? 0,
    };

    this.api.create('sessions', obj).subscribe({
      next: (sessions) => {
        if (sessions.sessions.is_error) {
          this.handleSessionCreationError(sessions.message);
        } else {
          this.handleSessionCreationSuccess();
        }

        this.flagSimpleAreas = false;
        this.showTables = false;

        // Reload calendar for new dates
        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  maderoAppointments(): void {
    this.submitAppt = true;
    this.disabledButtons = true;
    this.submitExists = false;
    this.flagSessionActive = false;
    this.disabledNewSession = false;
    this.disabledScheduleButton = false;

    const maderoFormValues = this.maderoForm.value;
    console.log('hola antes de las validaciones');
    const checkHours = this.isFoodTimes(
      this.startSession,
      this.endSession,
      maderoFormValues.cabinId,
      maderoFormValues.employeeId
    );

    console.log('-- Horas: ', checkHours);

    console.log(this.maderoForm);
    if (this.maderoForm.invalid) {
      console.log('holas aqui');
      this.submitExists = true;
      this.disabledScheduleButton = true;
      this.submitAppt = false;
      this.disabledButtons = false;

      return;
    }

    const startDateValidation = `${maderoFormValues.dateSession.year}-${maderoFormValues.dateSession.month}-${maderoFormValues.dateSession.day} ${this.startSession.hour}:${this.startSession.minute}:00`;

    if (!this.isValidDate(startDateValidation)) {
      this.disabledNewSession = true;
      this.messageNewSession = 'Por favor, verifica que la fecha de inicio sea valida!';

      return;
    }

    const endDateValidation = `${maderoFormValues.dateSession.year}-${maderoFormValues.dateSession.month}-${maderoFormValues.dateSession.day} ${this.endSession.hour}:${this.endSession.minute}:00`;

    if (!this.isValidDate(endDateValidation)) {
      this.disabledNewSession = true;
      this.messageNewSession = 'Por favor, verifica que la fecha de termino sea valida!';

      return;
    }

    const obj = {
      client_id: maderoFormValues.clientId,
      appoinmentId: maderoFormValues.apptId,
      dateSession: maderoFormValues.dateSession,
      cabinId: maderoFormValues.cabinId,
      timeStart: this.startSession,
      endTime: this.endSession,
      sessionNumber: maderoFormValues.sessionNumber,
      user_id: maderoFormValues.employeeId,
      assisted: 2,
      comments: maderoFormValues.comments,
      customAreas: maderoFormValues.customAreasSessions,
      flagCustom: maderoFormValues.flagCustom,
      completeSession: maderoFormValues.type ?? 0
    };

    this.api.create('sessions', obj).subscribe({
      next: (sessions) => {
        if (sessions.sessions.is_error) {
          this.handleSessionCreationError(sessions.message);
        } else {
          this.handleSessionCreationSuccess();
        }

        this.flagSimpleAreas = false;
        this.showTables = false;

        // Reload calendar for new dates
        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  scheduleVacations(): void {
    this.submitVacations = true;

    if (this.vacationsForm.invalid) {
      this.submitVacations = false;

      return;
    }

    const startDate = `${this.vacationsForm.value.startDate.year}-${this.vacationsForm.value.startDate.month}-${this.vacationsForm.value.startDate.day}`;
    const endDate = `${this.vacationsForm.value.endDate.year}-${this.vacationsForm.value.endDate.month}-${this.vacationsForm.value.endDate.day}`;
    const startHour = `${this.startVacations.hour}:${this.startVacations.minute}:${this.startVacations.minute}`;
    const endHour = `${this.endVacations.hour}:${this.endVacations.minute}:${this.endVacations.second}`;

    const obj = {
      startDate,
      endDate,
      startHour,
      endHour,
      officeId: this.vacationsForm.value.officeId,
      cabinId: this.vacationsForm.value.cabinId,
      employeeId: this.vacationsForm.value.employeeId
    };

    this.api.create('schedule/vacations', obj).subscribe({
      next: (vacations) => {
        this.fetchAppoinments(this.currentCalendarDate);
        this.modalClose.close();
      }
    })
  }

  scheduleCapacitation(): void {
    this.submitCapacitation = true;

    if (this.capacitationForm.invalid) {
      this.submitCapacitation = false;

      return;
    }

    // cut and creat object
    const dateCut = this.capacitationForm.value.startDateCap.split('-');
    const obj = {
      startDate: { day: dateCut[2], month: dateCut[1], year: dateCut[0] },
      startHour: this.startCapacitation,
      endHour: this.endCapacitation,
      officeId: this.capacitationForm.value.officeId, 
      cabinId: this.capacitationForm.value.cabinId,
      employeeId: this.capacitationForm.value.employeeId,
      customTitle: 'Junta',
      comments: this.capacitationForm.value.comments
    };

    this.api.create('sessions/capacitation', obj).subscribe({
      next: (session) => {
        setTimeout(() => {
          this.submitCapacitation = false;
          
          this.close();
          this.fetchAppoinments(this.currentCalendarDate);
        }, 1000);
      }
    });
  }

  changeHourSession(): void {
    this.disabledChangeTimeMessage = true;
    const obj = {
      start: this.changeTimeStart,
      end: this.changeTimeEnd
    };
    const sessionId = this.changeTimeForm.value.sessionId;

    this.api.update('update/change-time', sessionId, obj).subscribe({
      next: (changeTime) => {
        this.disabledChangeTimeMessage = false;
        this.close();

        // Reload all the informaiton
        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  dragDropEvent(newRoom: Number, newTime: string, infoSession: any): void {
    const diff = this.getMinuteDifference(infoSession.sessions.dateStart, infoSession.sessions.dateEnd);
    console.log('-- INFO: ', infoSession.sessions.dateStart, infoSession.sessions.dateEnd)
    console.log('-- DIFF: ', diff);

    const endDate = this.addMinutesToIso(newTime, diff);
    console.log('-- Dates: ', newTime, endDate);

    const obj = {
      startDate: this.formatIsoDate(newTime), //this.formatDate(startDate),
      endDate: this.formatIsoDate(endDate), //this.formatDate(endDate),
      newRoom: newRoom
    };
    console.log('-- OBJ: ', obj);
    
    this.api.update('v1/sessions/reschedule', infoSession.sessions.id, obj).subscribe({
      next: (reschedule) => {
        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  resizePerLessTime(newRoom: Number, newDateStart: string, newDateEnd: string, infoSession: any): void {
    const startDate = this.formatDate(new Date(newDateStart));
    const endDate = this.formatDate(new Date(newDateEnd));

    const obj = {
      startDate,
      endDate,
      newRoom
    };

    this.api.update('v1/sessions/reschedule', infoSession.sessions.id, obj).subscribe({
      next: (reschedule) => {
        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  showDataPerClient(event: any): void {
    if (event.value === undefined) return;

    this.flagSearchModal = false;
    const clientId = event.value;
    const clientDataSessions = this.perClientsChecks.find((data: any) => data.id === clientId);

    if (clientDataSessions) {
      this.clientName = clientDataSessions.complete;

      this.api.get(`sessions/perclient/${clientId}`).subscribe({
        next: (clientPackage) => {
          this.perClients = clientPackage.sessions;
          console.log('Clients: ', this.perClients)

          this.modalClose = this.modal.open(this.sessionsClients, { size: 'xl' });
        }
      })
    } else {
      this.flagSearchModal = true;
      this.modalClose = this.modal.open(this.sessionsClients, { size: 'xl' });
    }
  }

  openBoxClose(): void {
    const currentDate = new Date(this.calendarComponent.getApi().getDate()).toISOString().slice(0, 10);

    this.api.get(`close-box/${currentDate}`).subscribe({
      next: (closebox) => {
        this.closeBox = closebox.data;
        this.closeBoxChange = closebox.change;

        this.modalClose = this.modal.open(this.closeBoxModal, { size: 'xl' });
      }
    });
  }

  confirmData(status: number, total: number, id: number, dateToSend: string): void {
    const parameter: string = `${status}/${total}/${id}/${dateToSend}`;

    this.api.getById('confirm', parameter).subscribe({
      next: (confirmData) => {
        this.closeBox = confirmData.data;
      }
    });
  }

  confirmChangeData(status: number, total: number, dateToSend: string): void {
    const parameters = `${status}/${total}/${dateToSend}`;

    this.api.getById('confirm_change', parameters).subscribe({
      next: (confirmChange) => {
        this.closeBoxChange = confirmChange.data;
      }
    });
  }

  deleteSession(sessionId: number): void {
    this.api.delete('sessions', sessionId).subscribe({
      next: (session) => {
        this.modalClose.close();

        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  confirmAssitedToSession(type: number, sessionId: number): void {
    const url: string = `${sessionId}/${type}`;

    this.api.getById('sessions/assistance', url).subscribe({
      next: (confirm) => {
        this.messageAcceptance = confirm.message;
        this.typeColor = Number(confirm.type) === 1 ? 'alert-success' : 'alert-danger';
        this.disabledAcceptanceButton = true;

        setTimeout(() => {
          this.modalClose.close();
          this.typeColor = '';
          this.disabledAcceptanceButton = false;
          this.messageAcceptance = '';

          this.fetchAppoinments(this.currentCalendarDate);
        }, 2000);
      }
    });
  }

  confirmAssitedToSessionPost(): void {
    const info = this.cancelForm.value;
    const obj = {
      id: info.id,
      type: 2,
      comment: info.comments
    };

    this.api.create('sessions/noassistance', obj).subscribe({
      next: (confirm) => {
        this.messageAcceptance = confirm.message;
        this.typeColor = confirm.type === 1 ? 'alert-success' : 'alert-danger';
        this.disabledAcceptanceButton = true;

        setTimeout(() => {
          this.modalClose.close();
          this.typeColor = '';
          this.messageAcceptance = '';
          this.noAssistFlag = false;
          this.disabledAcceptanceButton = false;

          this.fetchAppoinments(this.currentCalendarDate);
        }, 2000);
      }
    });
  }

  updateDataSession(): void {
    if (this.updateFormSession.invalid) {
      return;
    }

    const updateFormSessionValue = this.updateFormSession.value;
    const obj = {
      sessionId: updateFormSessionValue.sessionId,
      cabinOrigin: updateFormSessionValue.originalCabin,
      cabinNum: Number(updateFormSessionValue.cabinNumber),
      startHour: this.startSession.hour,
      startMinute: this.startSession.minute,
      endHour: this.endSession.hour,
      endMinute: this.endSession.minute
    };

    console.log('-- Objeto: ', obj);
    this.api.update('update_session', updateFormSessionValue.sessionId, obj).subscribe({
      next: (data) => {
        this.modalClose.close();

        this.fetchAppoinments(this.currentCalendarDate);
      }
    });
  }

  // Methods returns control forms
  get rescheduleSessionFn(): any {
    return this.rescheduleForm.controls;
  }

  get advancePaymentFn(): any {
    return this.addPaymentsForm.controls;
  }

  get extraProductFn(): any {
    return this.extraProductsForm.controls;
  }

  get paymentsFormFn(): any {
    return this.paymentsForm.controls;
  }

  get missingFormFn(): any {
    return this.missingForm.controls;
  }

  get finalCommentsFormFn(): any {
    return this.finalCommentsForm.controls;
  }

  get apptValorationFormFn(): any {
    return this.apptValorationForm.controls;
  }

  get apptExistsV1Fn(): any {
    return this.apptExistsV1.controls;
  }

  get apptExistsFn(): any {
    return this.apptExists.controls;
  }

  get apptMaderoFn(): any {
    return this.maderoForm.controls;
  }

  get vacationsFormFn(): any {
    return this.vacationsForm.controls;
  }

  get capacitacionFormFn(): any {
    return this.capacitationForm.controls;
  }

  private setFlagsStatesFlow(): void {
    if (this.dataSessionInfo?.assisted !== 2) {
      this.acceptedSession = true;
      this.assistedFlag = false;
    }

    if (this.dataSessionInfo?.areas.length > 0) {
      this.areasWorked = this.dataSessionInfo?.areas.filter((area: any) => area.active === 0);
    }

    if (this.dataSessionInfo?.areasWorked.length > 0) {
      console.log('-- Cambio el flag');
      this.areasWorkedFlag = true;
    }

    if (this.dataSessionInfo?.typeSession === 2) {
      this.typeSession = true;
      // this.displayAdvancePaymentsButton = false;
    }

    this.disabledButtons = this.dataSessionInfo?.assisted === 0 ? true : false;

    if (this.dataSessionInfo?.sessionClose) {
      this.sessionFinishedFlag = true;
    }
  }
 
  // Process methods calendar section  
  async handleInformationData(sessionId: number | null, info: any): Promise<any> {
    if (!sessionId) {
      return;
    }

    console.log('-- INFO Variable: ', info);
    const dataInfo = await this.getDataPerSessionId(sessionId);
    console.log('-- Informacion de la sesion: ', dataInfo);
    this.dataSessionInfo = dataInfo.data;
    console.log('-- DATA SESSIONS INFO?: ', this.dataSessionInfo);
    this.setFlagsStatesFlow();

    if (this.dataSessionInfo?.assisted === 1) {
      this.assistedFlag = true;
    }
    //this.valorationFlag = this.dataSessionInfo?.appoinment?.id === 'N/A' ? true : false;
    //this.acceptedSession = this.dataSessionInfo?.assisted !== 2 ? true : false;
    console.log('-- Valor sessionClose: ', typeof this.dataSessionInfo?.sessionClose);

    // Set start hour and end hour
    const [hourMinutesStart, periodStart] = this.dataSessionInfo?.timeStart.split(" ");
    const [hourMinutesEnd, periodEnd] = this.dataSessionInfo?.timeEnd.split(" ");
    const [hoursStart, minutesStart] = hourMinutesStart.split(":").map(Number);
    const [hoursEnd, minutesEnd] = hourMinutesEnd.split(":").map(Number);

    this.startSession = { hour: hoursStart, minute: minutesStart, second: 0 };
    this.endSession = { hour: hoursEnd, minute: minutesEnd, second: 0 };

    // Check if remaining payment exists
    if (this.dataSessionInfo.package?.remaining_total) {
      this.hasRemaining = Number(this.dataSessionInfo.package.remaining_total) === 0;

      // check data for payments done flag
      if (this.hasRemaining) {
        this.paymentDoneFlag = true;
      }
    }

    // Get areas worked
    if (this.dataSessionInfo.areas.length !== 0) {
      this.areasWorked = this.dataSessionInfo.areas.filter((area: any) => area.active === 0);
    }

    // Return payments info
    this.paymentsInfo = this.dataSessionInfo.payments.map((dataPayment: any) => {
      if (this.dataSessionInfo.typeSession === 2) {
        return;
      }

      if (this.dataSessionInfo.numberSession === parseInt(dataPayment.session_number) && dataPayment.is_paid) {
        this.paymentDoneFlag = true;
      }

      return {
        id: dataPayment.id,
        sessionNumber: dataPayment.session_number,
        payment: dataPayment.payment,
        datePaid: dataPayment.date_paid
      };
    });

    // Set values in forms
    this.updateFormSession.patchValue({
      sessionId: this.dataSessionInfo?.session_id,
      originalCabin: this.dataSessionInfo?.cabin?.id,
      cabinNumber: this.dataSessionInfo?.cabin?.id,
      duration: this.dataSessionInfo?.package?.duration === '' ? '00:15' : this.dataSessionInfo?.package?.duration
    });

    this.rescheduleForm.patchValue({
      sessionId: this.dataSessionInfo?.session_id
    });

    // Areas Worked part
    this.missingForm.patchValue({
      sessionId: this.dataSessionInfo?.session_id,
      apptId: this.dataSessionInfo?.appoinment?.id,
      packageId: this.dataSessionInfo?.package?.id
    });

    // Payments part
    if (this.dataSessionInfo?.shouldPaid?.id) {
      this.disabledAmountField = true;
      const remainingInformation = this.paymentsInfo.find((pi: any) => Number(pi.sessionNumber) === this.dataSessionInfo?.numberSession);
      this.oldPayment = remainingInformation?.payment;
      this.saldoTotal = remainingInformation?.payment;

      this.paymentsForm.patchValue({
        sessionId: this.dataSessionInfo?.session_id,
        remainingPaymentId: remainingInformation?.id,
        amount: remainingInformation?.payment,
        apptId: this.dataSessionInfo?.appoinment?.id,
        originalAmount: remainingInformation?.payment
      });
    }

    // Modals
    if (info?.sessions.confirmed === 0) {
      this.modalClose = this.modal.open(this.confirmAssisted, { size: 'lg' });
    } else {
      this.modalClose = this.modal.open(this.modalContent, { size: 'xl' });
    }

    console.log('-- dataSessionInfo: ', this.dataSessionInfo);
    console.log('-- payments Info: ', this.paymentsInfo);
  }

  scrollSmoothToTime(date: Date, scroller: HTMLElement): void {
    const calendarEl = this.calendarRef.nativeElement;
    const slot = calendarEl.querySelector('.fc-timegrid-slot') as HTMLElement;
    console.log(scroller.scrollHeight, scroller.clientHeight);

    if (!slot) {
      console.warn('Slot not found!');
      return;
    }

    const slotHeight = slot.offsetHeight;
    const minutesPerSlot = 10;
    const pixelsPerMinute = slotHeight / minutesPerSlot;
    const totalMinutes = date.getHours() * 60 + date.getMinutes();
    const containerHeight = scroller.clientHeight;
    const maxScroll = scroller.scrollHeight - containerHeight;
    let targetScroll = (totalMinutes * pixelsPerMinute) - 100; //(containerHeight / 2);

    if (targetScroll < 0) targetScroll = 0;
    if (targetScroll > maxScroll) targetScroll = maxScroll;

    scroller.scrollTo({
      top: targetScroll,
      behavior: 'smooth'
    });
  }

  scrollPageToCalendar(): void {
    const calendarEl = this.calendarRef.nativeElement;

    calendarEl.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
  }

  waitAndScroll(date: Date, attempts = 0): void {
    const calendarEl = this.calendarRef?.nativeElement;
    if (!calendarEl) {
      console.warn('Calendar not ready');
      return;
    }

    const scrollers = calendarEl.querySelectorAll('.fc-scroller');
    console.log('All scrollers', scrollers)
    if (!scrollers.length) {
      if (attempts > 15) {
        console.warn('No scrollers found!');
        return;
      }

      setTimeout(() => {
        this.waitAndScroll(date, attempts + 1);
      }, 100);
      return;
    }

    let verticalScroller: HTMLElement | null = null;
    scrollers.forEach((el: any) => {
      if (el.scrollHeight > el.clientHeight) {
        verticalScroller = el;
      }
    });

    if (!verticalScroller) {
      console.warn('No vertical scroller found!');
      return;
    }

    this.scrollSmoothToTime(date, verticalScroller);
  }

  scrollToEventElement(eventId: string): void {
    const calendarEl = this.calendarRef.nativeElement;

    const eventEl = calendarEl.querySelector(
      `[data-event-id="${eventId}"]`
    ) as HTMLElement;

    if (!eventEl) {
      console.warn('Event element not found!');
      return;
    }

    eventEl.scrollIntoView({
      behavior: 'smooth',
      block: 'center', // 🔥 THIS FIXES YOUR ISSUE
    });
  }

  highlightEvent(eventId: string): void {
    const calendarEl = this.calendarRef.nativeElement;
    const eventEl = calendarEl.querySelector(`[data-event-id="${eventId}"]`) as HTMLElement;

    if (!eventEl) {
      console.warn('Event element not found!');
      return;
    }

    eventEl.classList.add('fc-event-highlight');
    setTimeout(() => {
      eventEl.classList.remove('fc-event-highlight');
    }, 2000);
  }

  calendarPerClient(event: any): void {
    this.selectedEventId = event.session_id;
    this.selectedEventDate = new Date(event.original_start);
    
    this.modal.dismissAll();

    setTimeout(() => {
      this.navigateToStoredEvent();
    }, 300);
  }

  navigateToStoredEvent(): void {
    if (!this.selectedEventDate) {
      console.warn('No event stored');
      return;
    }

    const calendarApi = this.calendarComponent.getApi();
    this.isManualNavigation = true;
    calendarApi.gotoDate(this.selectedEventDate);
  }

  afterEventsLoaded(): void {
    if (!this.selectedEventId) return;

    const calendarApi = this.calendarComponent.getApi();
    const eventFound = calendarApi.getEventById(this.selectedEventId);

    if (!eventFound || !eventFound.start) {
      console.warn('Event not found after load');
      return;
    }

    this.scrollPageToCalendar();
    setTimeout(() => {
      this.scrollToEventElement(eventFound.id);

      setTimeout(() => {
        this.highlightEvent(eventFound.id);
      }, 300);

    }, 400);

    this.selectedEventId = null;
    this.selectedEventDate = null;
  }

  showHistoricalComments(sessionId: Number | null): void {
    if (!sessionId) {
      this.historicalCommentsInfo = [];

      return;
    }

    const recordSelected = this.appointmesAgendaPerDay.filter((session: any) => session.sessions.id === sessionId);
    this.historicalCommentsInfo = recordSelected[0].sessions.history_comments;
  }

  redirectToUsers(sessionId: Number | null): void {
    if (!sessionId) {
      return;
    }

    const recordSelected = this.appointmesAgendaPerDay.filter((session: any) => session.sessions.id === sessionId);

    this.router.navigate(['/clients/show', recordSelected[0].client.id]);
  }

  createSessionsModal(info: any): void {
    let employeeInformation, employeeInformationV1;
    this.setDateForMeetings = info.date;
    const restDay = this.getRestDayNumber(info.date.getDay());
    const cabinInformation = this.cabins.filter((cabin: any) => cabin.id === Number(info.resource?.id));
    console.log('Cabinas: ', cabinInformation);
    console.log("information: ", info)
    let dataCanceled = false;

    this.flagTypeClient = 0;
    this.flagTypeSession = 0;
    this.disabledNewSession = false;
    this.showTables = false;
    this.flagClientOpen = false;
    this.flagSimpleArea = false;
    this.clientColSize = 12;
    this.showScheduleSession = 0;

    const currentDate = new Date(info.dateStr);
    console.log('-- Current date: ' , currentDate);
    console.log("Fecha seleccionada: ", currentDate.toLocaleDateString('es-MX'));
    const [hour, minute, second] = currentDate.toLocaleTimeString('es-MX', { hour12: false }).split(':');
    //const [day, month, year] = //currentDate.toLocaleDateString('es-MX').split('/');
    //const year = currentDate.getFullYear();
    //const month = currentDate.getMonth() + 1;
    //const day = currentDate.getDate();
    //console.log('-- Split date: ', day, month, year);
    this.startSession = { hour: parseInt(hour), minute: parseInt(minute), second: parseInt(second) };
    console.log('-- Inicio de sesion: ', this.startSession);

    if (cabinInformation[0].total_users > 1) {
    } else {
      employeeInformation = cabinInformation[0].employees[0];
    }

    if (cabinInformation[0].employees_v1.length) {
      employeeInformationV1 = cabinInformation[0].employees_v1.filter((emp: any) => emp.cabin_user_day === restDay);
    }

    if (employeeInformationV1 && !employeeInformationV1.length) {
      employeeInformationV1 = cabinInformation[0].employees_v1;
    }

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    // Depilation session
    this.apptExistsV1.patchValue({
      dateSession: {
        year: Number(year),
        month: Number(month),
        day: Number(day)
      },
      employeeId: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      employeeIdTemp: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      cabinId: cabinInformation[0].id,
      cabinNumber: cabinInformation[0].id
    });

    // Hidrafacial session
    this.apptExists.patchValue({
      dateSession: {
        year: Number(year),
        month: Number(month),
        day: Number(day)
      },
      employeeId: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      employeeIdTemp: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      cabinId: cabinInformation[0].id,
      cabinNumber: cabinInformation[0].id
    });

    this.maderoForm.patchValue({
      dateSession: {
        year: Number(year),
        month: Number(month),
        day: Number(day)
      },
      employeeId: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      employeeIdTemp: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      cabinId: cabinInformation[0].id,
      cabinNumber: cabinInformation[0].id
    });

    this.apptValorationForm.patchValue({
      dateSessionValue: {
        year: Number(year),
        month: Number(month),
        day: Number(day)
      },
      officeIdValue: (employeeInformationV1 && employeeInformationV1[0].office.id) ?? employeeInformation?.schedule_v1[0].office.id,
      employeeIdValue: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      employeeIdValueTemp: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      cabinIdValue: cabinInformation[0].id,
      cabinNumberValue: cabinInformation[0].id
    });

    // Capacitation session
    const formattedDate = `${year}-${month}-${day}`;
    this.capacitationForm.patchValue({
      officeId: (employeeInformationV1 && employeeInformationV1[0].office.id) ?? employeeInformation?.schedule_v1[0].office.id,
      cabinId: cabinInformation[0].id,
      employeeId: (employeeInformationV1 && employeeInformationV1[0].user.id) ?? employeeInformation?.employee_id,
      startDateCap: formattedDate,
    });

    this.blockFields();
    this.modalClose = this.modal.open(this.createSession, { size: 'xl' });
  }

  newPaymentsAddedSession(flag: boolean): void {
    this.newPaymentsAdded = flag;

    if (!this.newPaymentsAdded) {
      this.resetFieldsAdvancePayments();
    }
  }

  newExtraResources(flag: boolean): void {
    this.newExtraPays = flag;

    if (!this.newExtraPays) {
      this.resetExtraPayments();
    }
  }

  noAssistedUser(flag: boolean, form: number): void {
    if (form === 1) {
      this.cancelForm.patchValue({
        id: this.dataSessionInfo?.session_id,
        type: 2,
        comments: ''
      });
    } else {
      this.cancelForm.patchValue({
        id: this.dataSessionInfo?.session_id,
        type: 0,
        comments: ''
      });
    }

    this.noAssistFlag = flag;
  }

  showRescheduleForm(flag: boolean): void {
    this.rescheduleFlag = flag;
  }

  openNoAssisstForm(type: boolean, form: any): void {
    const cancelType = form === 1 ? 1 : 0;
    this.cancelForm.patchValue({
      id: this.dataSessionInfo?.session_id,
      type: cancelType,
      comments: ''
    });

    this.noAssistFlag = type;
   /*  if (form === 1) {
      this.cancelForm.patchValue({
        id: this.dataSessionInfo?.session_id,
        type: 2,
        comments: ''
      });
    } else {
      this.cancelForm.patchValue({
        id: this.dataSessionInfo?.session_id,
        type: 0,
        comments: ''
      });
    }

    this.noAssistFlag = type; */
  }

  close(): void {
    this.resetAllFlags();
    this.modalClose.close();
  }

  showFormEditSession(event: any) {
    this.editHourSession = !this.editHourSession;
  }

  changeHour(boolValue: boolean): void {
    if (boolValue) {
      console.log('hola: ', boolValue, this.updateFormSession);
      const splitData = this.updateFormSession.value.duration.split(':');
      const separationMinutes = +splitData[0] * 60 + +splitData[1];

      const hoursToMinutes =
        +this.startSession.hour * 60 + +this.startSession.minute;
      const initial = this.calculateHoursAndMinutes(hoursToMinutes, 0);
      const final = this.calculateHoursAndMinutes(
        hoursToMinutes,
        separationMinutes
      );

      this.startSession = {
        hour: initial.hour,
        minute: initial.minute,
        second: 0,
      };
      this.endSession = {
        hour: final.hour,
        minute: final.minute,
        second: 0,
      };
    } else {
      const hoursToMinutes =
        +this.startSession.hour * 60 + +this.startSession.minute;
      const initial = this.calculateHoursAndMinutes(hoursToMinutes, 0);
      const final = this.calculateHoursAndMinutes(hoursToMinutes, 15);

      this.startSession = {
        hour: initial.hour,
        minute: initial.minute,
        second: 0,
      };
      this.endSession = {
        hour: final.hour,
        minute: final.minute,
        second: 0,
      };
    }
  }

  resetFieldsAdvancePayments(): void {
    this.addPaymentsForm.get('paymentMethodId').setValue('0');
    this.addPaymentsForm.get('terminal').setValue('0');
    this.addPaymentsForm.get('paymentId').setValue('0');
    this.addPaymentsForm.reset();
    this.paymentMethodFlag = false;
  }

  resetExtraPayments(): void {
    this.extraProductsForm.get('paymentMethodId').setValue('0');
    this.extraProductsForm.get('terminal').setValue('0');
    this.extraProductsForm.get('paymentId').setValue('0');
    this.extraProductsForm.get('extra').reset();
    this.newExtraPays = false;
  }

  checkPaymentMethods(event: any, data: string): void {
    if (data === 'extra') {
      this.extraShowFlag = true;
      this.paymentMethodFlag = false;
    } else {
      this.extraShowFlag = false;
      this.paymentMethodFlag = false;
    }

    this.paymentsFilter = this.payments.filter((payment: Payments) => payment.payment_method_id === Number(event.target.value));
  }

  changeElement(event: any): void {
    const numberData = Number(event.target.value);

    if (numberData === 1 || numberData === 2) {
      this.saldoExtraTotal = this.saldoExtraTotal + 50 - this.lastProduct;

      if (this.lastProduct === 0 || this.lastProduct === 100) {
        this.lastProduct = 50;
      }

      this.extraProductsForm.patchValue({
        amount: 50
      });
    } else {
      this.saldoExtraTotal = this.saldoExtraTotal + 100 - this.lastProduct;

      if (this.lastProduct === 0 || this.lastProduct === 50) {
        this.lastProduct = 100;
      }

      this.extraProductsForm.patchValue({
        amount: 100
      });
    }
  }

  changePriceLabel(event: any): void {
    if (this.paymentsForm.value.changeAmount) {
      this.saldoTotal = event.target.value;
    }
  }

  changeAmountToPaid(event: any): void {
    if (event.target.checked) {
      this.disabledAmountField =  false;
    } else {
      this.disabledAmountField = true;
      this.saldoTotal = this.paymentsForm.value.originalAmount;

      this.paymentsForm.patchValue({
        amount: this.oldPayment
      });
    }

    this.paymentsForm.patchValue({
      changeAmount: event.target.checked
    });
  }

  workingAreas(event: any, id: number | string, status: number): void {
    if (status === 1 && event.target.checked) {
      this.disabledChecks = true;

      this.missingForm.patchValue({
        areas: id
      });
    }

    if (status === 2 && event.target.checked) {
      this.arrayIds.push(id);
      this.disabledAll = true;

      this.missingForm.patchValue({
        areas: this.arrayIds
      });
    }

    if (!event.target.checked) {
      if (status === 1) {
        this.disabledChecks = false;
        this.missingForm.patchValue({
          areas: ''
        });
      }

      if (status === 2) {
        this.disabledAll = false;
        const index = this.arrayIds.indexOf(id);

        if (!event.target.checked && index !== -1) {
          this.arrayIds.splice(index, 1);
        }

        this.missingForm.patchValue({
          areas: this.arrayIds
        });
      }
    }
  }

  private setLabel(type: number): string {
    let labelReturned: string = 'Selecciona un tipo de sesión';
    this.flagClientOpen = false;
    this.clientColSize = 12;

    switch (type) {
      case 1:
        labelReturned = 'Agenda una sesión de depilacion';//'Agenda una sesión de valoración';
        break;
      case 2:
        labelReturned = 'Agenda una sesión de depilación por área';
        break;
      case 3:
        labelReturned = 'Agendar vacaciones de colaboradoras';
        break;
      case 4: // 6
        labelReturned = 'Agenda una sesión de hidrafacial'
        break;
      case 5: // 8
        labelReturned = 'Agenda una sesión de radiofrecuencia';
        break;
      case 6: // 5
        labelReturned = 'Agenda una sesión de eterna juventud';
        break;
      case 10: // 7
        labelReturned = 'Agenda una sesión de valoración';
        break;
      case 11: //4
        const date = new Date(this.setDateForMeetings);
        this.capacitationForm.patchValue({
          startDate: {
            year: date.getFullYear(),
            month: ('0' + (date.getMonth() + 1)).slice(-2),
            day: ('0' + (date.getDate() + 1)).slice(-2)
          }
        });
        labelReturned = 'Junta';
        break;
      default:
        labelReturned = 'Agenda una sesión de depilación';
        break;
    }

    return labelReturned;
  }

  scheduleVacationsTemplate(event: any): void {
    this.startVacations = { hour: 9, minute: 0, second: 0 };
    this.endVacations = { hour: 21, minute: 0, second: 0 };

    this.modalClose = this.modal.open(this.scheduleVacationsModal, { size: 'lg' });
  }

  onDateSelected(date: NgbDateStruct, input: HTMLInputElement): void {
    const jsDate = new Date(date.year, date.month-1, date.day);

    this.calendarComponent.getApi().gotoDate(jsDate);
    //input.value = '';
  }

  clearDay(input: HTMLInputElement): void {
    input.value = '';

    this.calendarComponent.getApi().gotoDate(this.getMexicoCurrentDate());
  }

  getMexicoCurrentDate(): string {
    return new Intl.DateTimeFormat('sv-SE', {
      timeZone: 'America/Mexico_City'
    }).format(new Date());
  }

  // Get rest day number
  getRestDayNumber(restDay: number): number {
    let dayNumber = -1;
    switch (restDay) {
      case 0:
        dayNumber = 7;
        break;
      case 1:
        dayNumber = 1;
        break;
      case 2:
        dayNumber = 2;
        break;
      case 3:
        dayNumber = 3;
        break;
      case 4:
        dayNumber = 4;
        break;
      case 5:
        dayNumber = 5;
        break;
      case 6:
        dayNumber = 6;
        break;
      default:
        dayNumber = 0;
        break;
    }

    return dayNumber;
  }

  showForms(event: any): void {
    this.flagTypeSession = Number(event.target.value);
    this.dynamicMessage = this.setLabel(this.flagTypeSession);
    console.log("Evento show forms: ", event.target.value, this.dynamicMessage);

    if (this.flagTypeSession < 10) {
      this.config.spinners = false;
      this.endSession = this.timeEnd;
    } else {
      const totalMinutes = this.flagTypeSession === 10 ? 15 : 30;
      const totalOfMinutes = Number(this.startSession.hour) * 60 + Number(this.startSession.minute) + totalMinutes;
      
      /* const newDate = new Date(this.temporalSelectedDate);
      console.log('-- New Date: ', newDate); */
      this.startCapacitation = {
        ...this.startSession
        /* hour: newDate.getHours(),
        minute: newDate.getMinutes(),
        second: newDate.getSeconds() */
      };
      //newDate.setMinutes(newDate.getMinutes() + totalMinutes);
      console.log('-- End Date:', this.startSession);
      
      this.endSession = {
        hour: Math.floor(totalOfMinutes / 60),
        minute: totalOfMinutes % 60,
        second: Number(this.startSession.second),
      };
      this.endCapacitation = {
        hour: Math.floor(totalOfMinutes / 60),
        minute: totalOfMinutes % 60,
        second: Number(this.startSession.second),
      };

      console.log('-- FINAL VALUES: ', this.startSession, this.endSession, this.endCapacitation);

      this.config.spinners = true;
    }
  }

  typeUserForm(event: any): void {
    const typeForm = Number(event.target.value);

    this.flagTypeClient = 1;

    if (typeForm !== 1) {
      this.flagTypeClient = typeForm === 2 ? 2 : 0;

      this.apptValorationForm.patchValue({
        clientIdValue: 0
      });
    }
  }

  updateClientValoration(event: any): void {
    this. apptValorationForm.patchValue({
      clientIdValue: event.value
    });
  }

  async updateClientPackageV1(event: any): Promise<void> {
    this.disabledButtons = false;

    if (event.value === undefined) {
      this.showScheduleSession = 0;

      return;
    }

    const packages = await this.getPackages(event.value);
    console.log('Paquetes: ', packages);
    this.packages = packages.packages;
    const packageFormat = this.packages.map((packageInfo: any) => {
      return {
        value: packageInfo.id,
        label: `${packageInfo.type} ${packageInfo.packageShared} (${packageInfo.packageName} - ${packageInfo.sessionNumber} sesiones)`
      };
    });
    this.packageFilter = [{ options: packageFormat }];

    if (!this.packageFilter.length) {
      this.flagClientOpen = false;
      this.clientColSize = 12;
    } else {
      this.flagClientOpen = true;
      this.clientColSize = 6;
    }

    this.apptExistsV1.patchValue({
      clientId: this.packages[0].client.id
    });
  }

  loadInformationExistsV1(event: any): void {
    this. apptExistsV1.patchValue({
      packageId: event.value
    });

    const times: string[] = [];
    event.value.filter((info: any) => {
      const result = this.packages.filter((infoInner: any) => {
        if (info === infoInner.id) {
          if (infoInner.shared === 'Si') {
            times.push(infoInner.durationSharedNoFormat);

            return infoInner.durationSharedNoFormat;
          } else {
            times.push(infoInner.durationNoFormat);

            return infoInner.durationNoFormat;
          }
        }
      });
    });

    this.calculateTimesMultiplesPackages(times);
    this.disabledScheduleButton = true;
  }

  loadInformationExists(event: any): void {
    console.log('hola amigos');
    let totalSessions = 1;
    this.flagSimpleAreas = true;
    //this.flagSimpleArea = true;

    const apptInformation = this.packageFilter.filter((pf: any) => pf.id === Number(event.target.value));
    this.temporalPackageSelected = apptInformation;
    this.areasPackageSelected = apptInformation[0].package;

    console.log('Appt Information: ', apptInformation);
    console.log('-- Paquetes: ', this.areasPackageSelected);
    console.log('Event: ', event)
    const timeEndSession = this.getEndTime(apptInformation[0].durationNoFormat).split(':');
    const newDateToSet = new Date();
    newDateToSet.setHours(+timeEndSession[0], +timeEndSession[1], +timeEndSession[2]);
    const [hours, minutes, seconds] = newDateToSet.toLocaleTimeString('es-MX', 
      { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).split(':');
  
    this.timeEnd = {
      hour: parseInt(hours),
      minute: parseInt(minutes),
      second: parseInt(seconds)
    };

    this.temporalCompleteTime = this.timeEnd;
    this.endSession = this.timeEnd;
    this.endCapacitation = this.timeEnd;
    this.disabledButtons = true;

    this.apptExists.patchValue({
      totalSessions: apptInformation[0].remaining_sessions,
      sessionNumber: apptInformation[0].total_sessions === 0 ? totalSessions : apptInformation[0].total_sessions,
      officeId: apptInformation[0].client.office_id,
      apptId: apptInformation[0].appoinment_package
    });

    this.maderoForm.patchValue({
      totalSessions: apptInformation[0].remaining_sessions,
      sessionNumber: apptInformation[0].total_sessions === 0 ? totalSessions : apptInformation[0].total_sessions,
      officeId: apptInformation[0].client.office_id,
      apptId: apptInformation[0].appoinment_package
    });

    this.disabledScheduleButton = true;
    console.log('hpla amigos: ', this.apptExists);
  }

  private filterAreasPerType(type: Number, sessionId: Number) {
    console.log(this.areasPackageSelected[0]);
    const newAreasInfo = this.areasPackageSelected.filter((filterData: any) => this.storeAreasPackageIds.includes(filterData.sess_id));
    console.log('-- New Areas: ', newAreasInfo);
    return newAreasInfo;
  }

  storeAreaSelected(event: any, sessionId: number, type: number = 0): void {
    let flagCustomValue: number = 1;
    const checked = event.target.value;

    if (checked) {
      console.log('-- Sesion Id: ', sessionId);
      this.storeAreasPackageIds.push(sessionId);
      console.log('-- Store data:', this.storeAreasPackageIds);
      const infoAreaSelected = this.filterAreasPerType(type, sessionId);
      //this.storeAreasPackageIds.filter((pkg:any) => this.storeAreasPackageIds.includes(pkg.sess_id));
      const finalTime = this.getDurationSum(infoAreaSelected);

      const year = this.temporalSelectedDate.getFullYear();
      const month = String(this.temporalSelectedDate.getMonth() + 1).padStart(2, '0');
      const day = String(this.temporalSelectedDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`

      const dateToSet = new Date(`${formattedDate} ${finalTime}`);
      const [hours, minutes, seconds] = dateToSet.toLocaleTimeString('es-MX', { hour12: false }).split(':');

      this.timeEnd = { hour: Number(hours), minute: Number(minutes), second: Number(seconds) };
      this.endSession = this.timeEnd;
    } else {
      const index = this.storeAreasPackageIds.indexOf(sessionId);

      if (index !== -1) {
        this.storeAreasPackageIds.splice(index, 1);
      }

      if (!this.storeAreasPackageIds.length) {
        flagCustomValue = 0;
      }
      this.endSession = this.temporalCompleteTime;
    }

    this.apptExists.patchValue({
      flagCustom: flagCustomValue,
      customAreasSessions: this.storeAreasPackageIds
    });

    this.maderoForm.patchValue({
      flagCustom: flagCustomValue,
      customAreasSessions: this.storeAreasPackageIds
    });
  }

  isEnabledCustomAreas(event: any): void {
    if (Number(event.target.value) == 0) {
      this.showTables = true;
      this.showHideSimpleAreas([]);

      return;
    }

    this.showTables = false;
    this.endSession = this.temporalCompleteTime;
    this.flagSimpleArea = false;
    this.storeAreasPackageIds = [];

    this.apptExists.patchValue({
      customAreasSessions: this.storeAreasPackageIds,
      flagCustom: 0
    });

    this.maderoForm.patchValue({
      customAreasSessions: this.storeAreasPackageIds,
      flagCustom: 0
    });

    return;
  }

  showHideSimpleAreas(event: any): void {
    this.flagSimpleArea = !this.flagSimpleArea;
    let valueFlag: number = 1;

    if (!this.flagSimpleArea) {
      this.storeAreasPackageIds = [];
      valueFlag = 0;
    }

    this.apptExists.patchValue({
      customAreasSessions: this.storeAreasPackageIds,
      flagCustom: valueFlag
    });

    this.maderoForm.patchValue({
      customAreasSessions: this.storeAreasPackageIds,
      flagCustom: valueFlag
    });
  }

  updateClientsVacations(event: any): void {
    this.vacationsForm.patchValue({
      employeeId: event.options[0].value
    });
  }

  buttonClear(): void {
    const currentDate = new Date();
    const data = {
      value: 'calendarPerClientDate',
      date: `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`,
    };

    this.sharedServices.callMethodName(data);
    this.clientsSearchForm.get('searchClient').reset();
  }

  // Helpers
  private getEndTime(duration: string): string {
    const totalTime = duration.split(':');
    const initialTime = Number(this.startSession.hour) * 60 + Number(this.startSession.minute);
    const finalTime = Number(totalTime[0]) * 60 + Number(totalTime[1]) + initialTime;
    const endHour = Math.floor(finalTime / 60);
    const endMinute = Number(finalTime % 60);

    return `${endHour}:${endMinute}:00`;
  }

  private setCondition(info: any): boolean {
    console.log('-- Info: ', info, this.flagTypeSession)
    if (this.flagTypeSession === 2) {
      return info.type_id === 1 || info.type_id === 2 || info.type_id === 3 || info.type_id === 4 
             || info.type_id === 5 || info.type_id === 7; // 10, 2, 3
    }

    if (this.flagTypeSession === 11 || this.flagTypeSession === 10) { // 5
      return info.type_id === 10; 
    }

    return 1 === 1;
  }

  private calculateTimesMultiplesPackages(times: string[]): void {
    let sum = 0;

    for (let i = 0; i < times.length; i++) {
      const splitTimes = times[i].split(':');
      sum += Number(splitTimes[0]) * 60 + Number(splitTimes[1]);
    }

    const hoursToMinutes = Number(this.startSession.hour) * 60 + Number(this.startSession.minute);
    const final = this.calculateHoursAndMinutes(hoursToMinutes, sum);

    this.endSession = { hour: final.hour, minute: final.minute, second: 0 };
  }

  private calculateHoursAndMinutes(timeObject: number, sum: number): Times {
    const totalminutes = timeObject + sum;
    const hour = Math.floor(totalminutes / 60);
    const minute = totalminutes % 60;

    return { hour, minute };
  }

  private isFoodTimes(startSession: Times, endSession: Times, cabinId: number, userId: number): boolean {
    const startHour: string = `${startSession.hour}:${startSession.minute}:00`;
    const endHour: string = `${endSession.hour}:${endSession.minute}:00`;

    let flagCheckHours: boolean = false;
    let employeeStartFood: string = '';
    let employeeEndFood: string = '';

    const userData = this.employees.filter((userInfo: any) => {
      if (userInfo.id === userId) {
        employeeStartFood = userInfo.schedule.food_start;
        employeeEndFood = userInfo.schedule.food_end;

        return userInfo;
      }

      return;
    });

    if (userData.length === 0) {
      return true;
    }

    if (employeeStartFood >= startHour && employeeStartFood <= startHour && employeeEndFood <= endHour) {
      flagCheckHours = true;
    }

    return flagCheckHours;
  }

  private showValorationError(message: string): void {
    this.flagValueZero = true;
    this.disabledButtons = false;
    this.messageZero = message;
  }

  private handleSessionError(message: string): void {
    this.disabledButtons = false;
    this.disabledNewSession = true;
    this.disabledScheduleButton = true;
    this.messageNewSession = message;
  }

  private handleSuccessfulValoration(): void {
    this.disabledNewSession = false;
    this.flagValueZero = false;

    this.close();
    // Refresh data in calendar
    this.fetchAppoinments(this.currentCalendarDate);
  }

  private handleSessionCreationError(message: string): void {
    this.disabledButtons = false;
    this.disabledNewSession = true;
    this.disabledScheduleButton = true;
    this.messageNewSession = message;
  }

  private handleSessionCreationSuccess(): void {
    this.disabledButtons = true;
    this.disabledNewSession = false;
    this.submitExists = false;
    this.submitApptV1 = false;

    this.flagTypeClient = 0;
    this.flagTypeSession = 0;

    this.close();
    // TODO: Refresh to add new sessions or update sessions
    // TODO: Reset flags
  }

  private resetClientView(): void {
    this.showScheduleSession = 0;
    this.flagClientOpen = false;
    this.flagSimpleAreas = false;
    this.clientColSize = 12;
  }

  private handleNoPackages(): void {
    this.flagClientOpen = false;
    this.clientColSize = 12;
    this.showScheduleSession = 2;
    this.endSession = { hour: '', minute: '', second: '' };

    this.apptExists.patchValue({
      totalSessions: '',
      sessionNumber: ''
    });

    this.maderoForm.patchValue({
      totalSessions: '',
      sessionNumber: ''
    });
  }

  private getActiveSession(): any {
    return this.sessionAppExists.find((info: any) => info.sessions.length !== 0 && info.id === this.packageFilter[0].appoinment_package);
  }

  private getDurationSum(data: any): string {
    let sumTime = 0;
    for (let timeData of data) {
      const [hours, minutes] = timeData.duration.split(':');
      sumTime += +hours * 60 + +minutes;
      /* const [hours, minutes] = timeData[0].duration.split(':');
      sumTime += +hours * 60 + +minutes; */
    }

    const initialTime = Number(this.startSession.hour) * 60 + Number(this.startSession.minute);
    const finalTime = sumTime + initialTime;

    let endHour = Math.floor(finalTime / 60);
    let endMinute = Number(finalTime % 60);

    return `${endHour}:${endMinute}:00`;
  }

  private getMinuteDifference(start: string, end: string): number {
    const startDate = new Date(start);
    const endDate = new Date(end);

    return (endDate.getTime() - startDate.getTime()) / 60000;
  }

  private formatDate(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ` +
           `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  formatIsoDate(dateStr: string): string {
    const [datePart, timePart] = dateStr.split('T');
    const cleanTime = timePart.split('-')[0];
  
    return `${datePart} ${cleanTime}`;
  }

  addMinutesToIso(dateStr: string, minutes: number): string {
    const [datePart, timePart] = dateStr.split('T');
    const [hour, minute, second] = timePart.split(':').map(Number);
    const totalMinutes = hour * 60 + minute + minutes;

    const newHour = Math.floor(totalMinutes / 60);
    const newMinute = totalMinutes % 60;

    return `${datePart}T${String(newHour).padStart(2, '0')}:${String(newMinute).padStart(2, '0')}:${isNaN(second) ? '00' : second}`;
  }

  private resetAllFlags(): void {
    this.assistedFlag = false;
    this.submitAssisted = false;
    this.submitReschedule = false;
    this.submitExists = false;
    this.submitAdvancePayment = false;
    this.submitPayments = false;
    this.submitComments = false;
    this.submitValoration = false;
    this.submitApptV1 = false;
    this.submitAppt = false;
    this.submitVacations = false;
    this.submitCapacitation = false;
    this.editHourSession = false;
    this.uptHourSubmitExists = false;
    this.acceptedSession = false;
    this.disabledButtons = false;
    this.disabledAcceptanceButton = false;
    this.noAssistFlag = false;
    this.rescheduleFlag = false;
    this.areasWorkedFlag = false;
    this.newPaymentsAdded = false;
    this.paymentMethodFlag = false;
    this.extraShowFlag = false;
    this.newExtraPays = false;
    this.extraPaymentSession = false;
    this.submitExtraPayments = false;
    this.hasRemaining = false;
    this.paymentDoneFlag = false;
    this.isPaid = false;
    this.isPaidFlag = false;
    this.completeTransactions = false;
    this.disabledAmountField = false;
    this.valorationFlag = false;
    this.areasMissingSubmitted = false;
    this.areasFlagDone = false;
    this.disabledChecks = false;
    this.disabledAll = false;
    this.sessionFinishedFlag = false;
    this.typeSession = false;
    this.disabledNewSession = false;
    this.flagValueZero = false;
    this.flagSessionActive = false;
    this.disabledScheduleButton = false;
    this.flagEndTimeValidation = false;
    this.showTables = false;
    this.flagSimpleAreas = false;
    this.flagSimpleArea = false;
    this.flagClientOpen = false;
    this.disabledChangeTimeMessage = false;
    this.flagSearchModal = false;
    this.isManualNavigation = false;
  }

  /* isBlocked(roomId: string, start: Date, end: Date): boolean {
    if (!roomId) {
      console.log('holas blocked');
      return false;
    }

    console.log('Block: ', roomId, start, end);
    const value = this.blockedRanges.some(block => {
      if (block.roomId !== roomId) {
        console.log('is not the same room');
        return false;
      }

      console.log('Dentro del some: ', start, block.end, end, block.start);
      return (start < block.end && end > block.start);
    });

    console.log('Valor: ', value);
    return value;
  } */

  isBlocked(roomId: string, start: Date, end: Date): boolean {
    if (!roomId || isNaN(start.getTime()) || isNaN(end.getTime())) {
      console.log('iuno if');
      return false;
    }

    return this.blockedRanges.some((block: any) => {
      // Your data uses resourceId, not roomId
      console.log('Block: ', block, roomId);
      if (block.roomId != roomId) {
        console.log('dos if');
        return false;
      }

      // Convert the strings to Date objects
      const blockStart = new Date(block.start);
      const blockEnd = new Date(block.end);

      if (isNaN(blockStart.getTime()) || isNaN(blockEnd.getTime())) {
        console.error('Invalid blocked range:', block);
        return false;
      }

      // Check whether the selected time overlaps the blocked range
      const overlaps = start < blockEnd && end > blockStart;

      console.log({
        selectedStart: start.toString(),
        selectedEnd: end.toString(),
        blockStart: blockStart.toString(),
        blockEnd: blockEnd.toString(),
        overlaps
      });

      return overlaps;
    });
  }

  blockFields(): void {
    this.apptExistsV1.controls['employeeIdTemp'].disable();
    this.apptExists.controls['employeeIdTemp'].disable();
    this.maderoForm.controls['employeeIdTemp'].disable();
    this.apptValorationForm.controls['employeeIdValueTemp'].disable();
    this.maderoForm.controls['employeeIdTemp'].disable();
  }

  iconsMapFn(): void {
    this.modalClose = this.modal.open(this.iconsMap, { size: 'lg' });
  }

  isValidDate(dateStr: string): boolean {
    const regex = /^(\d{4})-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
    const match = dateStr.match(regex); 
    
    if (!match) {
      return false;
    }

    const [
      ,
      year,
      month,
      day,
      hour,
      minute,
      second
    ] = match.map(Number);

    return (
      month >= 1 && month <= 12 &&
      day >= 1 && day <= 31 &&
      hour >= 0 && hour <= 23 &&
      minute >= 0 && minute <= 59 &&
      second >= 0 && second <= 59
    );
  }

  /* createTitle(recordId: string, completeName: string, phone: string, timeStart: string, timeEnd: string): string {
    const checkPhone = phone.length > 0 ? phone : '';
    const titulo = `${recordId} ${completeName} (${checkPhone}) (${timeStart} a ${timeEnd})`;
    console.log('titulo: ', titulo);

    return titulo;
  } */
}